import o1 from '../../assets/Events/others1.jpg'
import o2 from '../../assets/Events/others2.jpg'
import o3 from '../../assets/Events/others3.jpg'
import o4 from '../../assets/Events/others4.jpg'
import o5 from '../../assets/Events/others5.jpg'
import o6 from '../../assets/Events/others6.jpg'
import o7 from '../../assets/Events/others7.jpg'
import o8 from '../../assets/Events/others8.jpg'

export const others = [
    {
        name: 'Temple Visit',
        img: o1
    },
    {
        name: 'Temple Visit',
        img: o2
    },
    {
        name: 'Temple Visit',
        img: o3
    },
    {
        name: 'Temple Visit',
        img: o4
    },
    {
        name: 'Thai Soc Dinner',
        img: o5
    },
    {
        name: 'Thai Soc Dinner',
        img: o6
    },
    {
        name: 'Thai Soc Dinner',
        img: o7
    },
    {
        name: 'Thai Soc Dinner',
        img: o8
    }
]